import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=016fefb5&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"
import style0 from "./RichText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports